import { mean } from 'lodash'
// import { MinimalTaskT } from 'ui-io/queries/tasks/todo-query'
// import { getRgba } from 'ui-lib'
// import { Colors } from '@blueprintjs/core'
import moment from 'moment'
// import { TooltipItem } from 'chart.js'
import {
  SEARCH_OPTIONS_BY_VIEW,
  ViewSearchOptions,
} from 'ui-io/task-io/task-search'

export const TODAY = moment().subtract(0, 'day').toDate().getTime().toString()
export const TODAY_MINUS_SEVEN_DAYS = moment()
  .subtract(7, 'day')
  .toDate()
  .getTime()
  .toString()

const NO_SEARCH_OPTIONS = Object.fromEntries(
  Object.keys(SEARCH_OPTIONS_BY_VIEW).map((key) => [key, false]),
) as ViewSearchOptions
const {
  taskTypes,
  scrapeStrategies,
  uuids,
  workstreamIds,
  muids,
  taskIds,
  priority,
  tags,
  text,
  fsmIds,
  maintenanceTypes,
} = SEARCH_OPTIONS_BY_VIEW
export const SLA_TASK_SEARCH_OPTIONS = {
  ...NO_SEARCH_OPTIONS,
  taskTypes,
  scrapeStrategies,
}

export const PUBLISH_SEARCH_OPTIONS = {
  ...NO_SEARCH_OPTIONS,
  uuids,
  workstreamIds,
  muids,
  taskIds,
  priority,
  tags,
  text,
  scrapeStrategies,
  fsmIds,
  maintenanceTypes,
}

// const taskPhaseToStateMap = {
//   edit: ['IN_EDITING'],
//   publication: ['READY_FOR_PUBLICATION'],
//   publicationBacklog: [''],
// }

// type TaskPhaseT = 'editBacklog' | keyof typeof taskPhaseToStateMap
// type TaskDurationDataT = {
//   editBacklog: number
//   edit: number
//   publicationBacklog: number
//   publication: number
// }

// type TaskAverageDataT = Record<TaskPhaseT, { time: number }>

// const defaultTaskDurationData: Record<TaskPhaseT, number> = {
//   editBacklog: 0,
//   edit: 0,
//   publicationBacklog: 0,
//   publication: 0,
// }

// export const retrieveSlaFromTasks = (
//   testJson: MinimalTaskT[],
// ): TaskDurationDataT[] =>
//   testJson.map((todo) => {
//     const initialTimeLog: Record<TaskPhaseT, number> = {
//       ...defaultTaskDurationData,
//     }

//     const initialLastOccurance: Record<TaskPhaseT, number> = {
//       ...defaultTaskDurationData,
//     }

//     const [timeLog, lastOccurance] = todo.status.reduce(
//       ([currLog, updatedlastOccurance], status) => {
//         if (!!status.timestamp) {
//           const { timestamp } = status
//           if (status.status === 'UNREVIEWED') {
//             const lastTimeStamp =
//               updatedlastOccurance.editBacklog === 0
//                 ? todo.timestamp
//                 : updatedlastOccurance.editBacklog

//             currLog.editBacklog += status.timestamp - lastTimeStamp
//             updatedlastOccurance.editBacklog = status.timestamp

//             Object.entries(updatedlastOccurance).forEach(
//               ([itemPhase, count]) => {
//                 const lastOccurancePhase = itemPhase as TaskPhaseT
//                 if (lastOccurancePhase !== 'editBacklog' && count !== 0) {
//                   currLog[lastOccurancePhase] +=
//                     timestamp - updatedlastOccurance[lastOccurancePhase]
//                   updatedlastOccurance[lastOccurancePhase] = 0
//                 }
//               },
//             )
//           } else {
//             if (updatedlastOccurance.editBacklog !== 0) {
//               currLog.editBacklog +=
//                 status.timestamp - updatedlastOccurance.editBacklog
//               updatedlastOccurance.editBacklog = 0
//             }
//             Object.entries(taskPhaseToStateMap).forEach(([phase, states]) => {
//               const currPhase = phase as TaskPhaseT
//               if (
//                 !!status.timestamp &&
//                 !!status.ticket_state &&
//                 states.includes(status.ticket_state)
//               ) {
//                 if (updatedlastOccurance[currPhase] === 0) {
//                   updatedlastOccurance[currPhase] = status.timestamp
//                 } else {
//                   currLog[currPhase] +=
//                     timestamp - updatedlastOccurance[currPhase]
//                   updatedlastOccurance[currPhase] = status.timestamp
//                 }

//                 Object.entries(updatedlastOccurance).forEach(
//                   ([itemPhase, count]) => {
//                     const lastOccurancePhase = itemPhase as TaskPhaseT
//                     if (itemPhase !== phase && count !== 0) {
//                       currLog[lastOccurancePhase] +=
//                         timestamp - updatedlastOccurance[lastOccurancePhase]
//                       updatedlastOccurance[lastOccurancePhase] = 0
//                     }
//                   },
//                 )
//               }
//             })
//           }
//         }
//         return [currLog, updatedlastOccurance]
//       },
//       [initialTimeLog, initialLastOccurance],
//     )

//     const currentTimeStamp = Math.round(+new Date())
//     Object.entries(lastOccurance).forEach(([itemPhase, count]) => {
//       if (
//         taskPhaseToStateMap[
//           itemPhase as keyof typeof taskPhaseToStateMap
//         ]?.includes(todo.status[-1]?.ticket_state ?? '')
//       ) {
//         if (count !== 0) {
//           timeLog[itemPhase as TaskPhaseT] +=
//             currentTimeStamp - lastOccurance[itemPhase as TaskPhaseT]
//           lastOccurance[itemPhase as TaskPhaseT] = 0
//         }
//       }
//     })

//     return timeLog
//   })

// export const getFormatedDuration = (timeDuration: number) => {
//   if (isNaN(timeDuration)) {
//     return 'No data'
//   }
//   const hours = timeDuration
//   if (hours < 24) {
//     return Math.floor(hours) + ' Hrs'
//   } else {
//     const days = hours / 24
//     return Math.floor(days) + (days < 2 ? ' day' : ' days')
//   }
// }

// const getAverageInHours = (taskList: TaskDurationDataT[], phase: TaskPhaseT) =>
//   mean(
//     taskList.filter((item) => item[phase] !== 0).map((item) => item[phase]),
//   ) / 3600

// export const getAverageDurationByPhase = (taskList: TaskDurationDataT[]) =>
//   Object.fromEntries(
//     Object.entries(defaultTaskDurationData).map(([phase]) => {
//       const key = phase as TaskPhaseT
//       return [
//         key,
//         {
//           time: getAverageInHours(taskList, key),
//         },
//       ]
//     }),
//   ) as TaskAverageDataT

// export const getChartData = (data: MinimalTaskT[]) => {
//   const avgData = getAverageDurationByPhase(retrieveSlaFromTasks(data))
//   return {
//     labels: ['Editing', 'Publishing'],
//     datasets: [
//       {
//         label: 'Backlog',
//         data: [avgData.editBacklog.time, avgData.publicationBacklog.time],
//         backgroundColor: [getRgba(Colors.GRAY1, 0.2)],
//         borderColor: [Colors.BLACK],
//         borderWidth: 0.5,
//         stack: 'Stack0',
//       },
//       {
//         label: 'Editing',
//         data: [avgData.edit.time, avgData.publication.time],
//         backgroundColor: [getRgba(Colors.GREEN5, 0.2)],
//         borderColor: [Colors.BLACK],
//         borderWidth: 0.5,
//         stack: 'Stack0',
//       },
//     ],
//   }
// }

// const isBacklog = (item: TooltipItem<'bar'>) =>
//   item.dataset?.label === 'Backlog'

// export const chartOptions = {
//   plugins: {
//     legend: {
//       display: false,
//     },
//     title: {
//       display: true,
//       text: 'Average Time (  in Hrs )',
//     },
//     tooltip: {
//       mode: 'index' as const,
//       itemSort: (item: TooltipItem<'bar'>) => (isBacklog(item) ? 1 : -1),
//       callbacks: {
//         label: (item: TooltipItem<'bar'>) => {
//           return (
//             (isBacklog(item) ? ' Backlog' : item.label) +
//             ' : ' +
//             getFormatedDuration(item.raw as number)
//           )
//         },
//       },
//     },
//   },
//   scales: {
//     x: {
//       stacked: true,
//     },
//     y: {
//       stacked: true,
//     },
//   },
//   responsive: true,
//   interaction: {
//     intersect: false,
//   },
// }
